import { v4 as uuidv4 } from 'uuid';

// Base64
export const toBase64 = (str) => {
    const bytes = new TextEncoder().encode(str);
    let binary = '';
    bytes.forEach(b => binary += String.fromCharCode(b));
    return btoa(binary);
};

// Generate clientId
export const getClientId = () => {
    return uuidv4();
};

// Generate clientSecret
// export const getClientSecret = (id, key) => {
//     return toBase64(id + key);
// };

export const getClientSecret = (id, key) => {
        let mykey = key ? key.toString() : ''
        console.log(mykey.length)
         console.log("my value",mykey)
        let finalst = id + key
        console.log(id.length)
       console.log("final value",finalst)
        return toBase64(finalst)
    // return toBase64(id + key);
   
};

const APP_VERSION = '1.1.0';
//   const REACT_APP_PREFIX = 'NZKlickExCardholder-AccessHub';

export const buildClientHeader = () =>{
    const REACT_APP_PREFIX = localStorage.getItem('pform') === "AU" ? 'AUKlickExCardholder-AccessHub' : 'NZKlickExCardholder-AccessHub';
    return `${REACT_APP_PREFIX}/${APP_VERSION} (${navigator.userAgent})`;
}


// WEBPACK FOOTER //
// ./src/utils/clientAuth.js